import '../Text/text.css';

const Text = (props) => {
  const { size, section, children, component, href } = props;
  const classNameText = `text_size_${size} text_section_${section}`;

  if (component === `div`) {
    return <div className={classNameText}>{children}</div>;
  } else if (component === `p`) {
    return <p className={classNameText}>{children}</p>;
  } else if (component === `span`) {
    return <span className={classNameText}>{children}</span>;
  } else if (component === `a`) {
    return (
      <a href={href} className={classNameText}>
        {children}
      </a>
    );
  }
};

export default Text;
